import * as React from 'react';

import { ListMonthsProps } from '../../components/list/months';
import ListMonth from '../../components/list/month';

import LoadMore from '../../components/month-selection/load-more';

const ListMonthsView: React.StatelessComponent<ListMonthsProps> = props => {

    const monthToDisplay = props.monthsData.filter(m => m.monthMoment.format("YYYY-MM") === props.currentMonth.format("YYYY-MM"))[0];
    if (!monthToDisplay) {
        document.documentElement.setAttribute("data-calendar-loading", "true");
        return <></>
    }

    document.documentElement.removeAttribute("data-calendar-loading");
    const access = document.getElementById("calendar-accessiblity-icons");
    if (access) {
        access.setAttribute("hidden", "")
    }
    return (
        <section className="ace-cal-list">
            <h2 className="visually-hidden">{props.text.listViewHeading}</h2>
            <ul className="ace-cal-list-months">
                {
                    <ListMonth key={`${monthToDisplay.monthMoment.month()}${monthToDisplay.monthMoment.year()}`} monthData={monthToDisplay} />
                }
            </ul>
        </section>
    )
}

export default ListMonthsView;